// ─────────────────────────────────────────────────────────────────
// Glass-i — DGU-consumables manual ISSUE API client (Stage DGU-CONSUMABLE-3).
// Over /api/erp/inventory/dgu-consumable-issues/*.
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

const BASE = '/api/erp/inventory/dgu-consumable-issues';
function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined ? resp.data.data : resp && resp.data;
}
const enc = encodeURIComponent;

export const dguConsumableIssueApi = {
  // Spacer BOM suggestion + geometry for a work order.
  suggest: (workOrderId) => client.get(`${BASE}/suggest`, { params: { workOrderId } }).then(unwrap),
  list: (params = {}) => client.get(BASE, { params }).then(unwrap),
  get: (id) => client.get(`${BASE}/${enc(id)}`).then(unwrap),
  // Record an issue + deduct every line (hard-blocked, atomic).
  create: (body = {}) => client.post(BASE, body).then(unwrap),
  // Return every line's qty to stock.
  reverse: (id) => client.post(`${BASE}/${enc(id)}/reverse`).then(unwrap),
  // Printable A4 issue slip — raw HTML (bypass axios JSON parse) for the iframe
  // viewer, fetched through the shared client so the Bearer token is attached.
  issueSlipHtml: (id) => client
    .get(`${BASE}/${enc(id)}/slip`, { responseType: 'text', transformResponse: (d) => d })
    .then((resp) => resp.data)
};

export default dguConsumableIssueApi;
